import { Component, OnInit } from '@angular/core';
import { RealizarConsultaService } from 'src/app/services/http/realizar-consulta.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Route } from '@angular/compiler/src/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-visualizar-consulta-lote',
  templateUrl: './visualizar-consulta-lote.component.html',
  styleUrls: ['./visualizar-consulta-lote.component.scss']
})
export class VisualizarConsultaLoteComponent implements OnInit {

  tableLoading: boolean = false;
  pesquisaDataInicio: any;
  pesquisaDataFim: any;
  lote: any = null;

  total;
  params = {
    sorting: {
      status: '',
      entrada: '',
      dataConsulta: 'desc',
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }

  id: number;


  constructor(private route: ActivatedRoute, private consultaService: RealizarConsultaService, private msgService: ModalMsgService) {
    this.id = this.route.snapshot.params['id'] || null;
  }

  ngOnInit() {
    this.updateResult();
  }

  changeOrder() {
    this.updateResult();
  }

  setPageSize(size) {
    this.params.per_page = size;
    this.updateResult();
  }

  nextPage() {
    this.updateResult();
  }

  async updateResult() {

    this.params.data = new Date();
    this.tableLoading = true;
    this.consultaService.resultadoConsultaLote(this.id, this.params)
      .then(r => {
        this.lote = r;
        this.total = this.lote.total || 0;
      })
      .catch(e => e)
      .finally(() => {
        this.tableLoading = false;
      });
  }

  executar() {
    this.consultaService.executaLote(this.id).then( data => {
      this.updateResult();
    });
  }

  
  atualizar() {
    this.updateResult();
  }

  download(lote:any) {
    this.consultaService.downloadLote(this.id).then(data => {
      let file = new FileReader();
      file.onload = () => {

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
        }else{
          const link = document.createElement('a');
          link.href = file.result as string;
          link.download = lote.nome+'.xlsx';
          link.addEventListener('click', () => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(file.result as string); 
          })
          document.body.appendChild(link);
          link.click();
        }
      }
      file.readAsDataURL(data);
    }, error => {
      console.error(error);
    });
  
      //this.msgService.openDialog('¯\\_(ツ)_/¯', 'Não implementado', 'info');
  
  }

  

}
